import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReviewPopupKYC from './review-popup';
import DocumentPreview from '../Create-Investment/documentpreview';
import ActivityLog from '../../Components/ActivityLog/activity-log';
import StatusButton from '../../Components/Onbaording/status-button';
import SectionStatusGrid from '../../Components/Onbaording/status-section';
import FileUploadDisplay from '../../Components/Onbaording/file-display';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';
// import StatusDropdown from "../../Components/Onbaording/section-status-dropdown";
import UserQuestionnaire from '../../Pages/Risk-Assessment/user-questionnarie';
import EDDModal from '../../Pages/Risk-Assessment/edd-modal';
import AuditStepper from '../../Components/Onbaording/onboarding-stepper';
import { formatDateTimeUTC } from '../../Constants/helper-functions';
import ScreeningPanel from '../../Components/Onbaording/ScreeningPanel';

const ReviewKycJointAccount = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const buttonRefs = useRef({});
  const { customerId } = useParams();
  const navigate = useNavigate();
  const [eddResponse, setEddResponse] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const roleName = useSelector((state) => state.user.roleName);
  const updateFieldStatus = useSelector(
    (state) => state.form.updateFieldStatus,
  );
  const [additionalDocuments, setAdditionalDocuments] = useState([]);
  const [additionalPhotographicDocuments, setAdditionalPhotographicDocuments] =
    useState([]);
  const dropdownRef = useRef();
  const [isOpenAction, setIsOpenAction] = useState(false);

  const [meetingData, setMeetingData] = useState([]);
  const [steps, setSteps] = useState([]);
  const [userStatus, setUserStatus] = useState(null);
  const [screening, setScreening] = useState([]);
  const [customerStatus, setCustomerStatus] = useState(null);

  const [sanctionResults, setSanctionResults] = useState(null);
  const [livenessConfirmed, setLivenessConfirmed] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState('');
  const [dvsTime, setDvsTime] = useState('');
  const [dvsMeessage, setDvsMeessage] = useState('');
  const location = useLocation();
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const [photoIdSecondText, setphotoIdSecondText] = useState(null);
  const [photoIdSecond, setphotoIdSecond] = useState(null);
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [fullName, setFullName] = useState(null);
  const [nonphotoIdText, setNonPhotoIdText] = useState('');
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [expiryDateSecond, setExpiryDateSecond] = useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [documentNumber, setDocumentNumber] = useState(null);

  const [applicantCountry, setApplicantCountry] = useState(null);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [nameFromBirth, setNameFromBirth] = useState('');
  const [status, setStatus] = useState('resubmit');
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [image, setImage] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [photoId, setphotoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [middleName, setMiddleName] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [thirdPartySign, setThirdPartySign] = useState(null);
  const [photoIdText, setPhotoIdText] = useState(null);
  const statusTextMap = {
    'to-review': 'To Review',
    'in-progress': 'In Progress',
    resubmit: 'Sent For Resubmit',
    approval: 'Approval',
  };
  const [photoIdFirstText, setphotoIdFirstText] = useState('');
  const [photoIdFirst, setphotoIdFirst] = useState(null);
  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [dob, setDob] = useState(null);
  const [formattedDOB, setFormattedDOB] = useState('');
  const [formerNames, setFormerNames] = useState(null);
  const [redAddress, setRedAddress] = useState(null);
  const [clientNo, setClientNo] = useState(null);
  const [description, setDescription] = useState(null);
  const [fileProof, setFileProof] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState(null);
  const [cardNumber, setCardNumber] = useState(null);
  const [cardNumberSecond, setCardNumberSecond] = useState(null);
  const [customerType, setCustomerType] = useState('');
  const [lastNameSignup, setLastNameSignup] = useState('');
  const [firstNameSignup, setFirstNameSignup] = useState('');
  const [email, setEmail] = useState('');
  const [statusData, setStatusData] = useState([]);
  /* Section list from the details response (onboarding_sections) —
     used for the per-section status pills & approve buttons. */
  const [onboardingSections, setOnboardingSections] = useState([]);
  /* Which section (if any) is currently being approved via its
     "Approve this section" button */
  const [approvingSection, setApprovingSection] = useState(null);
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const pendingQuestions = mapQuestions(
    (eddResponse?.pending || []).flatMap((item) => item.questions || []),
  );

  const completedQuestions = mapQuestions(
    (eddResponse?.completed || []).flatMap((item) => item.questions || []),
  );
  const completedGroups = (eddResponse?.completed || []).map((item) => ({
    id: item.id,
    requestedBy: item.requested_by?.name,
    respondedAt: item.responded_at,
    questions: mapQuestions(item.questions || []),
  }));
  const updateApplication = async (action) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      roleName == 'agent'
        ? action == 'approve'
          ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agent/customers/review/${customerId}/reject`
        : action == 'approve'
          ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agency/customers/review/${customerId}/reject`;

    const bodyData = {
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSendReverification = useCallback(
    debounce(async () => {
      let toastMessage = null;
      try {
        const response = await sendReverificationAPI();
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const sendReverificationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/customers/review/${customerId}/request-reverification`;
    // ✅ extract only IDs
    const sectionIds = statusData?.map((section) => section.id) || [];

    const bodyData = {
      sections: sectionIds,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          if (roleName == 'compliance_officer') {
            navigate('/customer-list', { state: { componentName: 'agency' } });
          } else {
            const historyStack = location.state?.historyStack || [];
            const lastRoute =
              historyStack.length > 0
                ? historyStack[historyStack.length - 1]
                : '/';

            navigate(lastRoute, {
              state: {
                fromViewHistory: true,
                historyStack: historyStack.slice(0, historyStack.length - 1),
              },
            });
          }
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const updateLiveness = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agent/customers/review/${customerId}/liveness-proof/meeting-flag`;

    const bodyData = {
      has_met_customer: true,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateLivenessCheck = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateLiveness();
        if (response.status == 200) {
          toastMessage = {
            message: 'Details updated successfully',
            type: 'success',
          };
          setLivenessConfirmed(true);
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        setLivenessConfirmed(false);
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/edd-responses`
          : `/api/v1/agency/customers/review/${customerId}/edd-responses`,
      );
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  const latest = sanctionResults?.latest;

  const fullNameSanction = latest?.request_payload?.full_name || '-';
  const screeningDate = latest?.response_timestamp || '-';

  const uiMessage = latest?.ui?.message;
  const uiSummary = latest?.ui?.summary;
  const sourcesChecked =
    latest?.response_payload?.data?.evidence?.sources_checked || [];

  const matchedSources = latest?.matched_sources || [];
  const decision = latest?.decision || {};
  const getSourceStyle = (source, isMatched) => {
    if (isMatched) {
      return 'bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200';
    }

    return 'bg-blue-50 text-blue-600 border-blue-200';
  };
  const formatSourceName = (source) => {
    return source
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };
  const getComplianceStatus = () => {
    if (!decision) return { label: '-', color: 'text-gray-500', sub: '' };

    if (!decision.pep && !decision.sanctions && !decision.adverse_media) {
      return {
        label: 'Clear',
        color: 'text-green-600',
        sub: uiMessage || 'No risk detected',
      };
    }

    if (decision.sanctions) {
      return {
        label: 'High Risk',
        color: 'text-red-600',
        sub: 'Sanctions match found',
      };
    }

    return {
      label: 'Review Required',
      color: 'text-amber-600',
      sub: 'Further checks recommended',
    };
  };
  const compliance = getComplianceStatus();
  const getStatusSanction = (val) => (val ? 'found' : 'completed');

  const sanctionsStatus = getStatusSanction(decision?.sanctions);
  const pepStatus = getStatusSanction(decision?.pep);
  const adverseStatus = getStatusSanction(decision?.adverse_media);
  const statusColorMap = {
    'to-review':
      'border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-30',
    'in-progress':
      'border-2  border-[#FFC421] text-[#FFC421] bg-[#FFC421] bg-opacity-30',
    resubmit:
      'border-2  border-[#3047EC] text-[#3047EC] bg-[#3047EC] bg-opacity-30',
    approval:
      'border-2  border-[#CC00FF] text-[#CC00FF] bg-[#CC00FF] bg-opacity-30',
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}`
          : `/api/v1/agency/customers/review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setEmail(response.data.open_account_information.email_address.value);
        setCustomerType(
          response.data.open_account_information.account_type.value,
        );
        setCustomerStatus(response.data.open_account_information.status.value);

        setUserStatus(response.data.status.id);

        setOnboardingSections(response.data.onboarding_sections || []);
        if (response.data.status.id != 6) {
          setScreening(response.data.screening);

          //Personal info
          setProfilePic(
            response.data.personal_information.profile_picture_file,
          );
          setFirstName(response.data.personal_information.first_name);
          setApplicantCountry(
            response.data.personal_information.applicant_country,
          );
          setSocialSecurityNumber(
            response.data.personal_information.social_security_number,
          );
          setLastName(response.data.personal_information.last_name);
          setMiddleName(response.data.personal_information.middle_name);
          setNameFromBirth(response.data.personal_information.is_birth_name);
          setFullName(response.data.personal_information.first_name);
          setFormerNames(response.data.personal_information.former_names);
          const date = new Date(response.data.personal_information.dob.value);
          const formattedDate = date.toLocaleDateString('en-GB');
          setDob(response.data.personal_information.dob);
          setFormattedDOB(formattedDate);
          setRedAddress(response.data.personal_information.address);
          setClientNo(response.data.open_account_information.client_id);
          // //Prove you
          setImage(response.data.liveness_proof.selfie);
          setLivenessConfirmed(response.data.liveness_proof.has_met_customer);

          // // Upload docs
          setThirdPartySign(
            response.data.proof_documents.has_prosecution_history,
          );
          setDescription(response.data.proof_documents.prosecution_description);
          setFileProof(response.data.proof_documents.prosecution_file);
          const proofDocuments = response.data.proof_documents || {};
          setAdditionalDocuments(proofDocuments.additional_documents || []);
          setAdditionalPhotographicDocuments(
            (proofDocuments.photographic_documents || []).slice(1),
          );
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date,
          );

          if (
            response.data.personal_information.applicant_country.value.id == 14
          ) {
            setExpiryDate(
              response.data.proof_documents.photographic_documents[0]
                .expiry_date,
            );
            setphotoId(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id,
            );
            setDocumentNumber(
              response.data.proof_documents.photographic_documents[0]
                .document_number,
            );
            setCardNumber(
              response.data.proof_documents.photographic_documents[0]
                ?.card_number,
            );
            setPhotoIdText(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.name,
            );

            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id != 2
            ) {
              setFilePhotographicId(
                response.data.proof_documents.photographic_documents[0].file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id == 2
            ) {
              setFileDriverLinsenceFront(
                response.data.proof_documents.photographic_documents[0].file,
              );
              setFileDriverLinsenceBack(
                response.data.proof_documents.photographic_documents[0]
                  .back_file,
              );
            }
          }

          if (
            response.data.personal_information.applicant_country.value.id != 14
          ) {
            console.log(
              'sjsjjs' +
                response.data.proof_documents.photographic_documents[0]
                  .document_type.value.id,
            );
            setphotoIdFirst(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id,
            );
            setphotoIdFirstText(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.name,
            );
            if (response.data.proof_documents.photographic_documents[1]) {
              setphotoIdSecond(
                response.data.proof_documents.photographic_documents[1]
                  .document_type.value.id,
              );
              setphotoIdSecondText(
                response.data.proof_documents.photographic_documents[1]
                  .document_type.value.name,
              );
              setDocumentNumberSecond(
                response.data.proof_documents.photographic_documents[1]
                  .document_number,
              );
              setCardNumberSecond(
                response.data.proof_documents.photographic_documents[1]
                  ?.card_number,
              );
              setExpiryDateSecond(
                response.data.proof_documents.photographic_documents[1]
                  .expiry_date,
              );
            }

            setDocumentNumber(
              response.data.proof_documents.photographic_documents[0]
                .document_number,
            );
            setCardNumber(
              response.data.proof_documents.photographic_documents[0]
                ?.card_number,
            );
            setExpiryDate(
              response.data.proof_documents.photographic_documents[0]
                .expiry_date,
            );

            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id != 2
            ) {
              setfilePhotographicIdFirst(
                response.data.proof_documents.photographic_documents[0].file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id == 2
            ) {
              setFileDriverLinsenceFrontFirst(
                response.data.proof_documents.photographic_documents[0].file,
              );
              setFileDriverLinsenceBackFirst(
                response.data.proof_documents.photographic_documents[0]
                  .back_file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[1] &&
              response.data.proof_documents.photographic_documents[1]
                .document_type.value.id != 2
            ) {
              setfilePhotographicIdSecond(
                response.data.proof_documents.photographic_documents[1].file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[1] &&
              response.data.proof_documents.photographic_documents[1]
                .document_type.value.id == 2
            ) {
              setFileDriverLinsenceFrontSecond(
                response.data.proof_documents.photographic_documents[1].file,
              );
              setFileDriverLinsenceBackSecond(
                response.data.proof_documents.photographic_documents[1]
                  .back_file,
              );
            }
          }
          setNonPhotoIdText(
            response.data.proof_documents.non_photogenic_id_type_name,
          );
          setfileNonPhotographicId(
            response.data.proof_documents.non_photogenic_file,
          );
          setVerificationStatus(
            response.data?.dvs_checks?.latest?.verification_result_code,
          );
          setDvsMeessage(
            response.data?.dvs_checks?.latest?.verification_result_message,
          );
          setDvsTime(response?.data?.dvs_checks?.latest?.created_at);
          setSanctionResults(response.data.sanctions_checks);
          if (roleName == 'agency_compliance') {
            setMeetingData(response.data.agent_meeting_flags);
          }
          setIsDataAvailable(true);
        }
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, 'error');
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/sections`
          : `/api/v1/agency/customers/review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data.sections);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getOverallJourney = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/overall-status`
          : `/api/v1/agency/customers/review/${customerId}/overall-status`,
      );
      const stageIconMap = {
        application_submitted: 'description',
        sanction_verification: 'gavel',
        identity_verification: 'verified_user',
        manual_review: 'manage_search',
        approved: 'check_circle',
        rejected: 'cancel',
        resubmission: 'refresh',
      };
      if (response.status == 200) {
        const stages = response.data?.stages || [];

        const mappedStages = stages.map((item) => ({
          ...item,
          key: item.stage,
          icon: stageIconMap[item.stage] || 'circle',
        }));

        setSteps(mappedStages);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  /* ------------------------------------------------------------------ */
  /*  Section approval — "Approve this section" approves EVERY field in  */
  /*  that section (same wiring as the individual Review KYC screen).    */
  /* ------------------------------------------------------------------ */
  const updateSectionStatus = async (sectionId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/customers/review/${customerId}/complete-section`;

    const bodyData = {
      section_id: sectionId,
      action: 'approve',
      user_id: customerId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };

  const handleApproveSection = useCallback(
    debounce(async (sectionKey, sectionId) => {
      if (!sectionId) return;
      let toastMessage = null;
      try {
        const response = await updateSectionStatus(sectionId);
        if (response.status == 200) {
          toastMessage = {
            message: response.message || 'Section approved successfully',
            type: 'success',
          };
          getStatus(); // refresh the section status grid
          getAllDetails();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false);
        setApprovingSection(null);
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 500);
        }
      }
    }, 1000),
    [customerId],
  );
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year}`;
    } catch (e) {
      return '-';
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );
      if (isOutside) {
        setDropdownOpen(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (customerId) {
      getEddResponses();
    }
  }, [customerId]);
  const handleDropdownToggleStatus = () => {
    setDropdownOpen((prev) => !prev);
  };
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
      getOverallJourney();
    }
  }, [customerId, updateFieldStatus]);

  /* Map each collapsible section to its API section entry. The details
     response includes `onboarding_sections` with a `section` key
     (PERSONAL_INFORMATION, PROVE_ITS_YOU, UPLOAD_PROOF_DOCS, ...);
     the /sections list (statusData) is used as a fallback. */
  const allSections =
    onboardingSections && onboardingSections.length
      ? onboardingSections
      : statusData || [];
  const sectionFor = (key, fallback) => {
    const match = allSections.find(
      (s) => String(s?.section || '').toUpperCase() === key,
    );
    return match || fallback || null;
  };
  const sectionMap = {
    personal: sectionFor('PERSONAL_INFORMATION', statusData[0]),
    liveness: sectionFor('PROVE_ITS_YOU', statusData[1]),
    proof: sectionFor('UPLOAD_PROOF_DOCS', statusData[2]),
  };

  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
              <span className="font-medium lg:text-lg text-sm">Review KYC</span>
            </div>
            <div className="flex space-x-2 w-full md:w-auto">
              <button
                onClick={() => {
                  setIsActivityLogOpen(true);
                }}
                className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
              >
                <img
                  src="/backward-10-seconds.svg"
                  alt="Add Icon"
                  className="mr-2"
                />
                <span className="inline pr-2">Activity Log</span>
              </button>
            </div>
          </div>

          <div>
            <div className="w-full p-4">
              {/* Open account information — static, non-collapsible section */}
              <section className="w-full overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_1px_2px_rgba(15,23,42,.04),0_20px_48px_-32px_rgba(15,23,42,.35)]">
                <div className="flex w-full flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3.5 sm:px-5">
                  <div className="flex min-w-0 items-center gap-3">
                    <span
                      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px]"
                      style={{ background: '#375AE714', color: '#375AE7' }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <circle cx="10" cy="7.6" r="3.2" />
                        <path d="M3.6 19.2a6.4 6.4 0 0 1 12.8 0" />
                        <path d="M16.4 4.9a3.2 3.2 0 0 1 0 5.4" />
                        <path d="M20.2 19.1a6.3 6.3 0 0 0-3.6-5.7" />
                      </svg>
                    </span>
                    <div className="min-w-0 leading-tight">
                      <h2 className="truncate text-[14.5px] font-bold tracking-tight text-slate-800">
                        Open Account Information
                      </h2>
                      <p className="text-[11px] font-medium text-slate-400">
                        Customer details on file
                      </p>
                    </div>
                    {customerType?.name ? (
                      <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DCE3F9] bg-[#EEF1FC] px-2.5 py-[5px] text-[10.5px] font-bold uppercase tracking-[.06em] text-[#375AE7]">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#375AE7]" />
                        {customerType.name}
                      </span>
                    ) : null}
                  </div>
                </div>
                <div className="border-t border-slate-100">
                  {/* ---- Fields (full width) ---- */}
                  <dl className="grid w-full grid-cols-1 gap-x-8 gap-y-4 px-4 py-4 sm:grid-cols-2 sm:px-5 lg:grid-cols-4">
                    {/* First Name */}
                    <div className="min-w-0">
                      <dt className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                        <span className="h-1 w-1 rounded-full bg-slate-300" />{' '}
                        First name
                      </dt>
                      <dd className="break-words text-[13.5px] font-medium leading-snug text-slate-700">
                        {firstNameSignup || '—'}
                      </dd>
                    </div>

                    {/* Last Name */}
                    <div className="min-w-0">
                      <dt className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                        <span className="h-1 w-1 rounded-full bg-slate-300" />{' '}
                        Last name
                      </dt>
                      <dd className="break-words text-[13.5px] font-medium leading-snug text-slate-700">
                        {lastNameSignup || '—'}
                      </dd>
                    </div>

                    {/* Email */}
                    <div className="min-w-0">
                      <dt className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                        <span className="h-1 w-1 rounded-full bg-slate-300" />{' '}
                        Email
                      </dt>
                      <dd className="break-all text-[13.5px] font-medium leading-snug text-slate-700">
                        {email || '—'}
                      </dd>
                    </div>
                  </dl>
                </div>
              </section>
            </div>
            {isActivityLogOpen && (
              <ActivityLog
                onClose={() => setIsActivityLogOpen(false)}
                customerId={customerId}
              />
            )}
            <div className="w-full  p-4">
              <AuditStepper steps={steps} />
            </div>
          </div>
          {userStatus != 6 && (
            <>
              <div className="w-full  p-4">
                <ScreeningPanel screening={screening} />
              </div>
              <div className="w-full  p-4">
                <div className="w-full mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-6 md:px-7 md:py-7 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
                  <SectionStatusGrid sections={statusData} />
                </div>
              </div>
            </>
          )}
          {isDataAvailable && (
            <>
              {/* Open Account Information — static, non-collapsible section */}

              {showPopup && currentField && (
                <ReviewPopupKYC
                  isOpen={showPopup}
                  currentField={currentField}
                  currentFieldName={currentFieldName}
                  currentFieldValue={currentFieldValue}
                  currentFieldType={currentFieldType}
                  onClose={() => setShowPopup(false)}
                />
              )}
              {/* End  */}
              {/* Personal Information */}
              <div className="w-full  p-4">
                <CollapsibleSection
                  icon={
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.9"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <circle cx="12" cy="8" r="3.6" />
                      <path d="M5 19.4a7 7 0 0 1 14 0" />
                    </svg>
                  }
                  accent="#375AE7"
                  title="Personal Information"
                  subtitle="Identity & address on file"
                  section={sectionMap.personal}
                  approving={approvingSection === 'personal'}
                  onApprove={() => {
                    setLoadingUpdate(true);
                    handleApproveSection('personal', sectionMap.personal?.id);
                  }}
                >
                  <div className="columns-1 gap-8 px-4 pb-2 pt-1 sm:px-5 md:columns-3">
                    {/* Profile Picture (only when present) */}
                    {profilePic.value && (
                      <div className="mb-1 flex break-inside-avoid items-start gap-4 py-2.5">
                        <img
                          src={profilePic.value?.presigned_url}
                          alt={`${fullName.value}`}
                          className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-slate-100"
                        />
                        <div className="flex min-w-0 flex-col gap-1.5 pt-1">
                          <div className="flex items-start justify-between gap-3">
                            <label
                              htmlFor="investmentType"
                              className="flex items-center whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                            >
                              Profile Picture
                            </label>
                            <StatusButton
                              status={profilePic.status}
                              count={profilePic.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  profilePic,
                                  'Profile Picture',
                                  profilePic.value?.presigned_url,
                                  '',
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <InfoField
                      label="First Name"
                      field={fullName}
                      fieldLabel="First Name"
                      fieldValue={fullName.value}
                      onStatusClick={handleStatusClick}
                      value={fullName.value}
                    />
                    <InfoField
                      label="Last Name"
                      field={lastName}
                      fieldLabel="Last Name"
                      fieldValue={lastName.value}
                      onStatusClick={handleStatusClick}
                      value={lastName.value}
                    />
                    {middleName && middleName.value && (
                      <InfoField
                        label="Middle Name"
                        field={middleName}
                        fieldLabel="Middle Name"
                        fieldValue={middleName.value}
                        onStatusClick={handleStatusClick}
                        value={middleName.value}
                      />
                    )}
                    {formerNames.value && formerNames.value.length > 0 && (
                      <InfoField
                        label="Customer's Former Name(s)"
                        field={formerNames}
                        fieldLabel="Customer's Former Name(s)"
                        fieldValue={formerNames.value}
                        onStatusClick={handleStatusClick}
                        value={formerNames.value}
                      />
                    )}
                    <InfoField
                      label="Date of Birth"
                      field={dob}
                      fieldLabel="Date of Birth"
                      fieldValue={formattedDOB}
                      onStatusClick={handleStatusClick}
                      value={formattedDOB}
                    />
                    <InfoField
                      label="Applicant's Country"
                      field={applicantCountry}
                      fieldLabel="Applicant's Country"
                      fieldValue={applicantCountry.value.name}
                      onStatusClick={handleStatusClick}
                      value={applicantCountry.value.name}
                    />
                    <InfoField
                      label="Residential Address"
                      field={redAddress}
                      fieldLabel="Residential Address"
                      fieldValue={redAddress.value.google_address}
                      onStatusClick={handleStatusClick}
                      value={redAddress.value.google_address}
                    />
                    <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
                      <label
                        htmlFor="investmentType"
                        className="flex items-center whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                      >
                        Client No
                      </label>
                      {clientNo?.value ? (
                        <div className="text-[13.5px] font-medium leading-snug text-slate-700">
                          {clientNo?.value}
                        </div>
                      ) : null}
                    </div>
                    {applicantCountry.value.id == 233 && (
                      <InfoField
                        label="Social Security Number"
                        field={socialSecurityNumber}
                        fieldLabel="Social Security Number"
                        fieldValue={socialSecurityNumber.value}
                        onStatusClick={handleStatusClick}
                        value={socialSecurityNumber.value}
                      />
                    )}
                    <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
                      <div className="flex items-start justify-between gap-3">
                        <label
                          htmlFor="investmentType"
                          className="flex items-center whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                        >
                          Is this name from birth?
                        </label>
                        <StatusButton
                          status={nameFromBirth.status}
                          count={nameFromBirth.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              nameFromBirth,
                              'Name from Birth',
                              nameFromBirth.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="birthName"
                            value={true}
                            checked={nameFromBirth.value == true}
                            disabled={true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="birthName"
                            value={false}
                            disabled={true}
                            checked={nameFromBirth.value == false}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </CollapsibleSection>
              </div>
              {/* End  */}
              {/* Image section */}
              <div className="w-full  p-4">
                <CollapsibleSection
                  icon={
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.9"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
                      <circle cx="12" cy="13" r="3" />
                    </svg>
                  }
                  accent="#0EA5E9"
                  title="Prove Its You"
                  subtitle="Liveness & meeting verification"
                  section={sectionMap.liveness}
                  approving={approvingSection === 'liveness'}
                  onApprove={() => {
                    setLoadingUpdate(true);
                    handleApproveSection('liveness', sectionMap.liveness?.id);
                  }}
                >
                  <div className="mt-4 flex flex-col gap-6 px-4 pb-5 pt-1 sm:px-5 md:flex-row">
                    {/* IMAGE SECTION */}
                    <div className="w-full md:max-w-[280px]">
                      <div className="flex items-center justify-between gap-3">
                        <span className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                          Photo Upload
                        </span>

                        <StatusButton
                          status={image.status}
                          count={image.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              image,
                              'Photo Upload',
                              image.value.presigned_url,
                              '',
                            )
                          }
                        />
                      </div>

                      <div className="relative mt-2.5 h-44 w-full overflow-hidden rounded-xl border border-slate-200 bg-gray-50">
                        <img
                          src={image.value.presigned_url}
                          alt="Uploaded"
                          className="h-full w-full object-cover"
                        />

                        <button
                          onClick={() => setFullscreen(true)}
                          className="absolute right-2 top-2 rounded-full bg-white/90 p-2 shadow transition hover:bg-white"
                        >
                          <img src="/show-full.svg" className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                    {/* RIGHT SIDE (STATUS + CONFIRMATION STACKED CLEANLY) */}
                    {roleName === 'agent' && (
                      <div className="flex-1">
                        <div className="flex items-start gap-3 rounded-xl border border-blue-100 bg-blue-50 p-4">
                          <input
                            type="checkbox"
                            checked={livenessConfirmed}
                            onChange={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateLivenessCheck(e);
                            }}
                            disabled={livenessConfirmed}
                            className="mt-1 w-4 h-4 accent-[#375AE7]"
                          />

                          <label className="text-sm leading-relaxed text-gray-800">
                            I confirm the person in the document matches the
                            customer I met in person.
                          </label>
                        </div>
                      </div>
                    )}
                    {roleName === 'agency_compliance' && (
                      <div className="flex-1">
                        {/* Header */}
                        <div className="mb-3 flex items-center justify-between">
                          <h3 className="text-sm font-semibold text-gray-700">
                            Team Member Meeting Status
                          </h3>

                          <span className="text-xs text-gray-400">
                            {meetingData?.length} team members
                          </span>
                        </div>

                        {/* Scrollable container for large lists */}
                        <div className="max-h-[420px] space-y-3 overflow-y-auto pr-2">
                          {meetingData?.map((agent) => (
                            <div
                              key={agent.agent_user_id}
                              className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-3 transition hover:bg-gray-50"
                            >
                              {/* LEFT: identity */}
                              <div className="flex min-w-0 items-center gap-3">
                                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-blue-600 text-sm font-semibold text-white">
                                  {agent.agent_name?.charAt(0) || 'A'}
                                </div>

                                <div className="min-w-0">
                                  <p className="truncate text-sm font-medium text-gray-800">
                                    {agent.agent_name}
                                  </p>
                                  <p className="truncate text-xs text-gray-500">
                                    {agent.agent_email}
                                  </p>
                                </div>
                              </div>

                              {/* RIGHT: status */}
                              <div className="flex items-center gap-3">
                                <span
                                  className={`rounded-full border px-2 py-1 text-[11px] font-medium ${
                                    agent.has_met_customer
                                      ? 'border-green-200 bg-green-50 text-green-600'
                                      : 'border-red-200 bg-red-50 text-red-600'
                                  }`}
                                >
                                  {agent.has_met_customer ? 'Met' : 'Not Met'}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </CollapsibleSection>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.value.presigned_url}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-md shadow-lg"
                  />
                </div>
              )}
              {/* End */}
              {/* Upload Proof Documents */}
              <div className="w-full  p-4">
                <CollapsibleSection
                  icon={
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.9"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <path d="M14 2v6h6" />
                      <path d="M9 13h6" />
                      <path d="M9 17h6" />
                    </svg>
                  }
                  accent="#F59E0B"
                  title="Upload Proof Documents"
                  subtitle="Prosecution history & identity documents"
                  section={sectionMap.proof}
                  approving={approvingSection === 'proof'}
                  onApprove={() => {
                    setLoadingUpdate(true);
                    handleApproveSection('proof', sectionMap.proof?.id);
                  }}
                >
                  {/* Prosecution */}
                  <div className="grid grid-cols-1 gap-8 px-4 pb-2 pt-1 sm:px-5 md:grid-cols-2">
                    <div className="flex min-w-0 flex-col">
                      <div className="flex items-start justify-between gap-3 py-2.5">
                        <label
                          htmlFor="investmentType"
                          className="whitespace-normal break-words text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                        >
                          Details of any current or recent prosecutions and
                          inquiries related to Money Laundering, terrorist
                          links, tax offences and corruption in respect of the
                          Individual
                        </label>
                        <StatusButton
                          status={thirdPartySign.status}
                          count={thirdPartySign.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              thirdPartySign,
                              'Details of any current or recent prosecutions and inquiries related to Money Laundering, terrorist links, tax offences and corruption in respect of the Individual',
                              thirdPartySign.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="yes"
                            checked={thirdPartySign.value === true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="no"
                            checked={thirdPartySign.value === false}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                      {thirdPartySign.value === true && (
                        <InfoField
                          label="Description"
                          field={description}
                          fieldLabel="Description"
                          fieldValue={description.value}
                          onStatusClick={handleStatusClick}
                          value={description.value}
                        />
                      )}
                    </div>
                    {thirdPartySign.value === true && (
                      <div className="flex min-w-0 flex-col">
                        <FileUploadDisplay
                          label="Upload Proof"
                          fileData={fileProof}
                          onFileClick={handleFileClick}
                        />
                      </div>
                    )}
                  </div>
                  {/* Extra details */}
                  <div className="grid grid-cols-1 gap-8 px-4 pb-2 pt-1 sm:px-5 md:grid-cols-2">
                    {/* Photographic ID(s) */}
                    <div className="flex min-w-0 flex-col">
                      {applicantCountry.value.id == 14 && (
                        <>
                          <div className="flex items-start justify-between gap-3 py-2.5">
                            <label
                              htmlFor="investmentType"
                              className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 flex items-center"
                            >
                              Photographic ID
                            </label>
                          </div>
                          {photoIdText ? (
                            <div className="text-[13.5px] font-medium text-slate-700">
                              {photoIdText}
                            </div>
                          ) : null}
                          {(photoId == 1 || photoId == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoId == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicId}
                                onFileClick={handleFileClick}
                              />
                              {photoId == 1 && (
                                <InfoField
                                  label="Passport Number"
                                  field={documentNumber}
                                  fieldLabel="Passport Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                              {photoId == 3 && (
                                <InfoField
                                  label="Document Number"
                                  field={documentNumber}
                                  fieldLabel="Document Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                            </>
                          )}
                          {photoId == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFront}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBack}
                                onFileClick={handleFileClick}
                              />
                              <InfoField
                                label="Driver's License Number"
                                field={documentNumber}
                                fieldLabel="Driver's License Number"
                                fieldValue={documentNumber.value}
                                onStatusClick={handleStatusClick}
                                value={documentNumber.value}
                              />
                              <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
                                <div className="flex items-start justify-between gap-3">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center whitespace-normal words-break"
                                  >
                                    Card Number
                                  </label>
                                  <StatusButton
                                    status={cardNumber.status}
                                    count={cardNumber.comments?.length}
                                    disabled={true}
                                    openSection={() =>
                                      handleStatusClick(
                                        cardNumber,
                                        'Card Number',
                                        cardNumber.value,
                                        '',
                                      )
                                    }
                                  />
                                </div>
                                {cardNumber?.value ? (
                                  <div className="text-[13.5px] font-medium leading-snug text-slate-700">
                                    {cardNumber.value}
                                  </div>
                                ) : null}
                              </div>
                            </>
                          )}
                          <InfoField
                            label="Expiry Date"
                            field={expiryDate}
                            fieldLabel=" Expiry Date"
                            fieldValue={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                            onStatusClick={handleStatusClick}
                            value={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                          />
                        </>
                      )}
                      {applicantCountry.value.id != 14 && (
                        <>
                          <div className="flex items-start justify-between gap-3 py-2.5">
                            <label
                              htmlFor="investmentType"
                              className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                            >
                              Select First Photographic ID
                            </label>
                          </div>
                          {photoIdFirstText ? (
                            <div className="text-[13.5px] font-medium text-slate-700">
                              {photoIdFirstText}
                            </div>
                          ) : null}
                          {(photoIdFirst == 1 || photoIdFirst == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdFirst == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicIdFirst}
                                onFileClick={handleFileClick}
                              />
                              {photoIdFirst == 1 && (
                                <InfoField
                                  label="Passport Number"
                                  field={documentNumber}
                                  fieldLabel="Passport Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                              {photoIdFirst == 3 && (
                                <InfoField
                                  label="Document Number"
                                  field={documentNumber}
                                  fieldLabel="Document Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                            </>
                          )}
                          {photoIdFirst == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontFirst}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackFirst}
                                onFileClick={handleFileClick}
                              />
                              <InfoField
                                label="Driver's License Number"
                                field={documentNumber}
                                fieldLabel="Driver's License Number"
                                fieldValue={documentNumber.value}
                                onStatusClick={handleStatusClick}
                                value={documentNumber.value}
                              />
                              <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
                                <div className="flex items-start justify-between gap-3">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center whitespace-normal words-break"
                                  >
                                    Card Number
                                  </label>
                                  <StatusButton
                                    status={cardNumber.status}
                                    count={cardNumber.comments?.length}
                                    disabled={true}
                                    openSection={() =>
                                      handleStatusClick(
                                        cardNumber,
                                        'Card Number',
                                        cardNumber.value,
                                        '',
                                      )
                                    }
                                  />
                                </div>
                                {cardNumber?.value ? (
                                  <div className="text-[13.5px] font-medium leading-snug text-slate-700">
                                    {cardNumber.value}
                                  </div>
                                ) : null}
                              </div>
                            </>
                          )}
                          <InfoField
                            label="Expiry Date"
                            field={expiryDate}
                            fieldLabel="Expiry Date"
                            fieldValue={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                            onStatusClick={handleStatusClick}
                            value={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                          />
                          <div className="flex items-start justify-between gap-3 py-2.5">
                            <label
                              htmlFor="investmentType"
                              className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                            >
                              Select Second Photographic ID
                            </label>
                          </div>
                          {photoIdSecondText ? (
                            <div className="text-[13.5px] font-medium text-slate-700">
                              {photoIdSecondText}
                            </div>
                          ) : null}
                          {(photoIdSecond == 1 || photoIdSecond == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdSecond == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicIdSecond}
                                onFileClick={handleFileClick}
                              />
                              {photoIdSecond == 1 && (
                                <InfoField
                                  label="Passport Number"
                                  field={documentNumberSecond}
                                  fieldLabel="Passport Number"
                                  fieldValue={documentNumberSecond.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumberSecond.value}
                                />
                              )}
                              {photoIdSecond == 3 && (
                                <InfoField
                                  label="Document Number"
                                  field={documentNumberSecond}
                                  fieldLabel="Document Number"
                                  fieldValue={documentNumberSecond.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumberSecond.value}
                                />
                              )}
                            </>
                          )}
                          {photoIdSecond == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontSecond}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackSecond}
                                onFileClick={handleFileClick}
                              />
                              <InfoField
                                label="Driver's License Number"
                                field={documentNumberSecond}
                                fieldLabel="Driver's License Number"
                                fieldValue={documentNumberSecond.value}
                                onStatusClick={handleStatusClick}
                                value={documentNumberSecond.value}
                              />
                              <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
                                <div className="flex items-start justify-between gap-3">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center whitespace-normal words-break"
                                  >
                                    Card Number
                                  </label>
                                  <StatusButton
                                    status={cardNumberSecond.status}
                                    count={cardNumberSecond.comments?.length}
                                    disabled={true}
                                    openSection={() =>
                                      handleStatusClick(
                                        cardNumberSecond,
                                        'Card Number',
                                        cardNumberSecond.value,
                                        '',
                                      )
                                    }
                                  />
                                </div>
                                {cardNumberSecond?.value ? (
                                  <div className="text-[13.5px] font-medium leading-snug text-slate-700">
                                    {cardNumberSecond.value}
                                  </div>
                                ) : null}
                              </div>
                            </>
                          )}
                          <InfoField
                            label="Expiry Date"
                            field={expiryDateSecond}
                            fieldLabel="Expiry Date"
                            fieldValue={
                              expiryDateSecond
                                ? new Date(
                                    expiryDateSecond.value,
                                  ).toLocaleDateString('en-GB')
                                : ''
                            }
                            onStatusClick={handleStatusClick}
                            value={
                              expiryDateSecond
                                ? new Date(
                                    expiryDateSecond.value,
                                  ).toLocaleDateString('en-GB')
                                : ''
                            }
                          />
                        </>
                      )}
                    </div>

                    {/* Non Photographic ID (only rendered when applicable — no empty gap) */}
                    {photoId != 2 && (
                      <div className="flex min-w-0 flex-col">
                        <div className="flex items-start justify-between gap-3 py-2.5">
                          <label
                            htmlFor="investmentType"
                            className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                          >
                            Non Photographic ID
                          </label>
                        </div>
                        {nonphotoIdText.value ? (
                          <span className="text-[13.5px] font-medium text-slate-700">
                            {nonphotoIdText.value}
                          </span>
                        ) : null}
                        <FileUploadDisplay
                          label="Uploaded Document"
                          fileData={fileNonPhotographicId}
                          onFileClick={handleFileClick}
                        />
                      </div>
                    )}
                  </div>
                  <AdditionalDocumentsReadOnly
                    documents={additionalDocuments}
                    photographicDocuments={additionalPhotographicDocuments}
                    onFileClick={handleFileClick}
                    onStatusClick={handleStatusClick}
                  />
                </CollapsibleSection>
              </div>
              {/* End  */}
              {(pendingQuestions.length > 0 || completedGroups.length > 0) && (
                <div className="bg-white s rounded-2xl p-4">
                  <div className="bg-white border rounded-2xl p-4 mt-4">
                    {pendingQuestions.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={pendingQuestions}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={true}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}
                    {completedGroups.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={completedGroups}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={false}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}{' '}
                  </div>
                </div>
              )}

              <div className="mt-6 flex items-center bg-[#005A9C] p-4">
                {/* Right Section: Download Button */}
                <div className="flex w-full items-center justify-end">
                  {customerStatus != 'active' && (
                    <div
                      ref={dropdownRef}
                      className="relative mr-4 inline-block"
                    >
                      {/* Button */}
                      <div
                        className="flex w-40 cursor-pointer items-center justify-between border border-white px-2 py-2 text-sm rounded-full"
                        onClick={() => setIsOpenAction(!isOpenAction)}
                      >
                        <span className="pl-4 text-right text-white">
                          Actions
                        </span>
                        <span className="text-gray-500">
                          {' '}
                          <img
                            src="/white-dropdown.svg"
                            alt="document-download"
                            className="pr-2"
                          />
                        </span>
                      </div>

                      {/* Dropdown Menu */}
                      {isOpenAction && (
                        <div className="absolute right-0 top-[-250%] z-10 w-40 rounded-md bg-white p-2 text-xs text-black shadow-lg">
                          <ul>
                            <li
                              onClick={() => {
                                const historyStack =
                                  location.state?.historyStack || [];
                                const lastRoute =
                                  historyStack.length > 0
                                    ? historyStack[historyStack.length - 1]
                                    : '/';

                                navigate(lastRoute, {
                                  state: {
                                    fromViewHistory: true,
                                    historyStack: historyStack.slice(
                                      0,
                                      historyStack.length - 1,
                                    ),
                                  },
                                });
                              }}
                              className="cursor-pointer p-2 hover:bg-[#375AE7] hover:text-white"
                            >
                              Back
                            </li>
                            <li
                              onClick={(e) => {
                                setLoadingUpdate(true);
                                handleUpdateApplication(e, 'reject');
                              }}
                              className="cursor-pointer p-2 text-[#FF5050] hover:bg-[#375AE7] hover:text-[#FF5050]"
                            >
                              Reject Application
                            </li>
                            <li
                              onClick={(e) => {
                                setLoadingUpdate(true);
                                handleUpdateApplication(e, 'resubmit');
                              }}
                              className="cursor-pointer p-2 text-[#FF5050] hover:bg-[#375AE7] hover:text-[#FF5050]"
                            >
                              Send for resubmit
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}

      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
const unwrapVerificationValue = (field) => {
  let value = field;
  let depth = 0;
  while (
    value &&
    typeof value === 'object' &&
    Object.prototype.hasOwnProperty.call(value, 'value') &&
    depth < 4
  ) {
    value = value.value;
    depth += 1;
  }
  return value;
};

const isNonEmptyDocumentValue = (value) => {
  const unwrapped = unwrapVerificationValue(value);
  return (
    unwrapped !== null &&
    unwrapped !== undefined &&
    unwrapped !== '' &&
    !(typeof unwrapped === 'string' && unwrapped.trim() === '')
  );
};

const documentFieldLabel = (key) =>
  key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());

const getDocumentFile = (field) => {
  let file = unwrapVerificationValue(field);
  if (Array.isArray(file)) file = file[0];
  if (file && file.file && typeof file.file === 'object') file = file.file;
  if (typeof file === 'string' && file.trim()) {
    return { presigned_url: file, file_name: 'View document' };
  }
  return file && (file.presigned_url || file.url || file.file_url)
    ? file
    : null;
};
const AdditionalDocumentsReadOnly = ({
  documents = [],
  photographicDocuments = [],
  onFileClick,
  onStatusClick,
}) => {
  const allDocuments = [
    ...photographicDocuments.map((document) => ({
      document,
      photographic: true,
    })),
    ...documents.map((document) => ({ document, photographic: false })),
  ];
  if (!allDocuments.length) return null;

  // These are transport/verification identifiers rather than user-entered
  // document fields. Keep the table driven by the API's remaining keys.
  const ignoredKeys = new Set([
    'id',
    'uuid',
    'unique_id',
    'verification_id',
    'document_id',
    'document_type_code',
    'file',
    'back_file',
  ]);

  const rows = allDocuments.flatMap(
    ({ document, photographic }, documentIndex) => {
      const type =
        unwrapVerificationValue(document.document_type_name) ||
        unwrapVerificationValue(document.document_type) ||
        (photographic ? 'Photographic document' : 'Additional document');
      const fieldRows = Object.entries(document).filter(
        ([key, value]) =>
          !ignoredKeys.has(key) &&
          !key.endsWith('_id') &&
          key !== 'document_type_name' &&
          key !== 'document_type' &&
          isNonEmptyDocumentValue(value),
      );
      const fileRows = [
        ['Main document', document.file],
        ['Back of document', document.back_file],
      ].filter(([, value]) => getDocumentFile(value));
      const valueRows = fieldRows.map(([key, field]) => ({
        key: `${documentIndex}-${key}`,
        type,
        field: documentFieldLabel(key),
        value: unwrapVerificationValue(field),
        verification:
          field && typeof field === 'object' && field.value !== undefined
            ? field
            : null,
      }));
      const documentFileRows = fileRows.map(([field, fileField]) => ({
        key: `${documentIndex}-${field}`,
        type,
        field,
        file: getDocumentFile(fileField),
        verification:
          fileField &&
          typeof fileField === 'object' &&
          fileField.value !== undefined
            ? fileField
            : null,
      }));
      return [...valueRows, ...documentFileRows];
    },
  );

  const displayValue = (value) => {
    const unwrapped = unwrapVerificationValue(value);
    if (typeof unwrapped === 'object') {
      return unwrapped?.name || unwrapped?.label || JSON.stringify(unwrapped);
    }
    return String(unwrapped);
  };

  return (
    <div className="w-full p-4">
      <CollapsibleSection
        title="Additional Documents"
        subtitle="Supporting and alternate photographic documents"
        accent="#F59E0B"
        defaultOpen={true}
      >
        <div className="overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_1px_2px_rgba(15,23,42,.04),0_20px_48px_-32px_rgba(15,23,42,.35)]">
          <div className="overflow-x-auto">
            <table className="w-full border-separate border-spacing-0 text-xs">
              <thead className="bg-slate-50/70 text-left text-[10px] uppercase tracking-wide text-slate-400">
                <tr>
                  <th className="px-4 py-3 font-semibold">Document type</th>
                  <th className="px-4 py-3 font-semibold">Field</th>
                  <th className="px-4 py-3 font-semibold">Value</th>
                  <th className="px-4 py-3 font-semibold">File</th>
                  <th className="px-4 py-3 font-semibold">Review</th>
                </tr>
              </thead>
              <tbody className="text-sm font-medium text-slate-800">
                {rows.map((row) => (
                  <tr
                    key={row.key}
                    className="border-t border-slate-100 align-top hover:bg-slate-50/60"
                  >
                    <td className="px-4 py-3 whitespace-nowrap">{row.type}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-slate-600">
                      {row.field}
                    </td>
                    <td className="px-4 py-3 min-w-[14rem] break-words">
                      {row.file ? 'Uploaded file' : displayValue(row.value)}
                    </td>
                    <td className="px-4 py-3 min-w-[13rem]">
                      {row.file ? (
                        <button
                          type="button"
                          onClick={() => onFileClick(row.file)}
                          className="cursor-pointer text-left text-slate-800 underline"
                        >
                          {row.file.file_name ||
                            row.file.name ||
                            'View document'}
                        </button>
                      ) : null}
                    </td>
                    <td className="px-4 py-3">
                      {row.verification ? (
                        <StatusButton
                          status={row.verification.status}
                          count={row.verification.comments?.length}
                          openSection={() =>
                            onStatusClick(
                              row.verification,
                              `${row.type} - ${row.field}`,
                              row.file || displayValue(row.value),
                              row.file ? 'file' : '',
                            )
                          }
                        />
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CollapsibleSection>
    </div>
  );
};
const SECTION_STATUS_STYLES = {
  approved: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  completed: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  pending: 'border-amber-200 bg-amber-50 text-amber-700',
  rejected: 'border-red-200 bg-red-50 text-red-700',
  in_review: 'border-sky-200 bg-sky-50 text-sky-700',
};

/* ================================================================== */
/*  CollapsibleSection — modern expandable section card                */
/*  - click the header to expand / collapse                            */
/*  - shows the section.status pill (when `section` is provided)       */
/*  - shows the "Approve this section" button (when section has id)    */
/*  - children render inside an animated collapsing body               */
/* ================================================================== */
const CollapsibleSection = ({
  icon,
  accent = '#375AE7',
  title,
  subtitle,
  pill,
  section,
  onApprove,
  approving = false,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const statusKey = section?.status ? String(section.status).toLowerCase() : '';
  const statusPill =
    statusKey && SECTION_STATUS_STYLES[statusKey] ? (
      <span
        className={`hidden items-center gap-1.5 rounded-full border px-2.5 py-[5px] text-[10.5px] font-semibold uppercase tracking-[.06em] sm:inline-flex ${SECTION_STATUS_STYLES[statusKey]}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {statusKey
          .split('_')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ')}
      </span>
    ) : null;

  return (
    <section className="mt-2 overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_1px_2px_rgba(15,23,42,.04),0_20px_48px_-32px_rgba(15,23,42,.35)]">
      {/* Header (click to toggle) */}
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') setOpen((o) => !o);
        }}
        className="flex w-full cursor-pointer select-none flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3.5 transition-colors hover:bg-slate-50/70 sm:px-5"
      >
        <div className="flex min-w-0 items-center gap-3">
          <span
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px]"
            style={{
              background: `${accent}14`,
              color: accent,
            }}
          >
            {icon}
          </span>
          <div className="min-w-0 leading-tight">
            <h2 className="truncate text-[14.5px] font-bold tracking-tight text-slate-800">
              {title}
            </h2>
            {subtitle ? (
              <p className="text-[11px] font-medium text-slate-400">
                {subtitle}
              </p>
            ) : null}
          </div>
          {statusPill}
          {pill}
        </div>

        <div className="flex shrink-0 items-center gap-2">
          {section?.id ? (
            <span
              role="button"
              onClick={(e) => {
                e.stopPropagation();
                if (!approving) onApprove();
              }}
              className={`inline-flex h-9 items-center gap-2 rounded-lg bg-[#375AE7] px-4 text-xs font-bold tracking-wide text-white shadow-md shadow-[#375AE7]/30 transition-all duration-200 active:scale-[0.97] ${
                approving
                  ? 'cursor-wait opacity-70'
                  : 'hover:-translate-y-0.5 hover:bg-[#2F4FD0] hover:shadow-lg hover:shadow-[#375AE7]/40'
              }`}
            >
              {approving ? (
                <span className="h-3 w-3 animate-spin rounded-full border-2 border-white border-t-transparent" />
              ) : (
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              )}
              {approving ? 'Approving…' : 'Approve this section'}
            </span>
          ) : null}
          <span
            className={`flex h-7 w-7 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-400 shadow-sm transition-transform duration-300 ${
              open ? 'rotate-180' : ''
            }`}
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
      </div>

      {/* Collapsing body */}
      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-out ${
          open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div className="border-t border-slate-100">{children}</div>
        </div>
      </div>
    </section>
  );
};

/* ================================================================== */
/*  InfoField — consistent label + value row                           */
/*  Renders only when a value exists — empty fields take no space and  */
/*  show no placeholder. When `field` is provided it keeps the original */
/*  StatusButton (status, comment count, review popup) behaviour.      */
/* ================================================================== */
const InfoField = ({
  label,
  field,
  fieldLabel,
  fieldValue,
  fieldType = '',
  onStatusClick,
  value,
  wide = false,
}) => {
  const isEmpty =
    value === null ||
    value === undefined ||
    value === '' ||
    (typeof value === 'string' && value.trim() === '');

  return (
    <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
      <div className="flex items-start justify-between gap-3">
        <label
          htmlFor="investmentType"
          className={`flex items-start whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 ${
            wide ? 'w-40 md:w-full' : ''
          }`}
        >
          {label}
        </label>
        {field ? (
          <StatusButton
            status={field.status}
            count={field.comments?.length}
            openSection={() =>
              onStatusClick(field, fieldLabel, fieldValue, fieldType)
            }
          />
        ) : null}
      </div>
      {/* Value row renders only when a value exists — empty fields take
          no space and show no placeholder */}
      {!isEmpty ? (
        <div className="break-words text-[13.5px] font-medium leading-snug text-slate-700">
          {value}
        </div>
      ) : null}
    </div>
  );
};
export default ReviewKycJointAccount;
